import React from "react";
import { Container } from "@mui/material";
const WrapContainer = ({ children, maxWidth }) => {
  return (
    <Container
      maxWidth={maxWidth ? "lg" : false}
      style={{
        padding: "16px 8px"
      }}>
      {children}
    </Container>
  );
};
export default WrapContainer;
